import { endpoint } from 'services/endpoint';
import { http } from 'services/http';
import { TMonthlyFeeApi } from './types';

export const monthlyFee: TMonthlyFeeApi = {
	getEMerchant: () => http.get(endpoint.monthlyFee.GET_EMERCHANTS).then(response => response.data),
	getMonthlyFee: () =>
		http.get(endpoint.monthlyFee.GET_MONTHLY_FEES).then(response => response.data),
	getFeeClasses: () =>
		http.get(endpoint.monthlyFee.GET_FEE_CLASSES).then(response => response.data),
	getMonthlyFeeList: params =>
		http.get(endpoint.monthlyFee.GET_MONTHLY_FEE_LIST, { params }).then(response => response.data),
	addMonthlyFee: payload =>
		http.post(endpoint.monthlyFee.ADD_MONTHLY_FEE, payload).then(response => response.data),
	deleteMonthlyFee: params =>
		http.delete(endpoint.monthlyFee.DELETE_MONTHLY_FEE(params.monthlyFeeId)),
};
